<template>
  <div>
      <v-dialog max-width="350" v-model="SEOBasicsDialog">
        <v-card tile flat width="100%">
            <v-card-title>
            </v-card-title>
            <v-card-text>
                <v-switch label="Page Shows on Web Searches" v-model="SEOPage.SEO"
                />
                <ContentEditableField style="padding:15px;"
                :FieldObject="SEOPage" :FieldName="'Overview'"
                :FieldValue="SEOPage.Overview" @UpdateContentEditableField="UpdateContentEditableField" :AdditionalSaveMethod="''" />
                <v-combobox
                        v-model="SEOPage.KeyWords"
                        :items="KeyWords"
                        label="KeyWords"
                        multiple
                        chips
                        >
                </v-combobox>
            </v-card-text>
            <v-card-text  v-if="SEOPage.SEO">
                Web Preview
                <v-list-item style="width:100%;padding-top:10px;padding-left:20px;border: 1px solid #ccc !important;" three-line> 
                                       
                    <v-list-item-content>
                        <v-list-item-title class="caption" style="margin-bottom:-6px;">{{DefaultPath+SEOPage.PageRoute}}</v-list-item-title>
                        <v-list-item-subtitle class="text-h7">
                        <v-btn  class="underlinehover" style="padding-left:0px;text-transform: capitalize;font-size: 0.925em;color: #1a0dab!important;" text plain depressed>
                            <span>{{System.Name}} || </span>
                        <span v-if="ActiveGroup && IsGroupView">{{ActiveGroup.name}} || </span> {{SEOPage.Name}} <v-icon color="#1a0dab" small dark>{{SEOPage.PageIcon}}</v-icon></v-btn>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle style="display: block;" v-html="SEOPage.Overview">
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="DeactivateSEODialog()" dark color="warning">
                    Cancel</v-btn>
                    <v-spacer>
                    </v-spacer>
                    <v-btn  @click="UpdateSEOBasics()"  dark color="success">
                        Save
                    </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-navigation-drawer :app="!MiniView" hide-overlay
                    mini-variant v-model="SiteDialog"
                    :permanent="!MiniView || MiniView && SiteDialog" mini-variant-width="100"
                    :style="!$route.meta.DataSingleBuilder || $route.name === 'SystemConfig'? 'z-index:8;height: 100%;top:65px;position: fixed;'
                    : 'z-index:2;height: 100%;top:60px;position: fixed;'"
                   >	
                    <v-list-item class="px-2">
                    <v-list-item-avatar>
                    <v-img :src="ActiveGroup && ActiveGroup.logo ? ActiveGroup.logo : require('@/assets/logo.png')"></v-img>
                    </v-list-item-avatar>
                </v-list-item>
                <v-divider></v-divider>
                <v-list dense>
                     <v-list-item
                    v-for="main in FilteredTopItems"
                    :key="main.itemObjKey"
                    link
                    >
                     <v-btn @click="ActivateSelectedMain(main)">
                        <v-icon>{{main.icon}}</v-icon>
                            <v-badge color="warning" v-if="main.notifications" left>
                        <span slot="badge"> {{main.notifications}}</span>
                        </v-badge>
                    </v-btn>
                    </v-list-item>
                    <v-list-item
                    v-for="main in Computedsitenavitems"
                    :key="main.itemObjKey"
                    link
                    >
                     <v-btn @click="ActivateSelectedMain(main)">
                        <v-icon>{{main.icon}}</v-icon>
                            <v-badge color="warning" v-if="main.notifications" left>
                        <span slot="badge"> {{main.notifications}}</span>
                        </v-badge>
                    </v-btn>
                    </v-list-item>
                    
                </v-list>
                </v-navigation-drawer>
             <v-navigation-drawer :right="MainDialRight" :app="MiniView" class="elevation-2" :style="MainDialStyling" v-if="SelectedMainDialog" v-model="SelectedMainDialog">
                <v-list v-if="SelectedMain">       
                     <v-card flat  v-if="SelectedMain.PreDialog">
                         <v-card-title class="settingsfont">
                               {{SelectedMain.title}}<v-spacer></v-spacer><v-icon @click="SelectedMain = ''">mdi-chevron-left</v-icon>
                            </v-card-title>                            
                            <v-card-text class="settingsfont" v-if="SelectedMain.IMG">
                                <v-img :src="SelectedMain.IMG"/>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-html="SelectedMain.Writeup">
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer>
                                </v-spacer>
                                <v-btn @click="ActivateSelectedMain(SelectedMain,true)">
                                Go
                                </v-btn>
                            </v-card-actions>
                     </v-card>            
                        <v-card flat  v-if="!SelectedMain.PreDialog">
                            <v-card-title class="settingsfont">
                                {{SelectedMain.title}}<v-spacer></v-spacer><v-icon @click="SelectedMain = ''">mdi-chevron-left</v-icon>
                            </v-card-title>
                             <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Web Forms'">
                                 <v-list class="transparent">
                                     <!-- uhm little something jsut asking. we don't want any quick config on web forms? -->
                                        <v-list-item style="padding-left: 0px;">
                                            <v-chip @click="NavigatetoWebFormBuilder()" >Add Web Form <v-icon>mdi-plus</v-icon></v-chip>
                                        </v-list-item>
                                        <v-list-item @click="NavigatetoWebFormEditor(webform.id)"
                                        dense v-for="webform in WebForms" :key="webform.itemObjKey"
                                        :style="'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'"
                                        >
                                        {{webform.DisplayName}}
                                        </v-list-item>
                                 </v-list>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Page Layout'">
                                <v-list dense class="transparent">					
                                    <v-list v-for="(tab,i) in PageTabs" :key="tab.itemObjKey">									
                                    <v-list-item									
                                    @dragover.prevent @drop.prevent="Tabdragfinish(i, $event)">									
                                        <v-list-item-avatar size="20">									
                                                    <v-icon v-if="tab.Elements.length>0" small style="display:block;" :id="i+'ShowElementsConfig'" @click="ShowTabElements(i)">mdi-chevron-down</v-icon>									
                                                    <v-icon small style="display:none;" :id="i+'HideElementsConfig'" @click="HideTabElements(i)">mdi-chevron-up</v-icon>									
                                                </v-list-item-avatar>									
                                        <v-list-item-title  :draggable="true" @dragstart="Tabdragstart(tab,i, $event)" @click="OpenDialog(tab,i)">{{tab.Name? tab.Name : tab.DataViewName}}</v-list-item-title>									
                                            <v-list-item-avatar size="20" @click.prevent="AdjustRowAmount(tab,i)">									
                                                    <v-icon small class="links--text actionicon">mdi-plus-thick</v-icon>									
                                                </v-list-item-avatar>									
                                                									
                                                									
                                    </v-list-item>									
                                    <v-list :id="i+'ElementsConfig'" style="display:none;padding-left:40px;">									
                                                <v-list-item									
                                                    @click="OpenDialog(elmnt,elmntindex,true,i),ShowTabElements(i)"									
                                                    v-for="(elmnt, elmntindex) in tab.Elements"									
                                                    :key="elmnt.itemObjKey"									
                                                    link									
                                                    @dragover.prevent @drop.prevent="Elmntdragfinish(tab,i,elmnt,elmntindex, $event),ShowTabElements(i)"									
                                                >									
                                                    <v-list-item-title v-text="elmnt.Name? elmnt.Name : elmnt.DataViewName"									
                                                    :draggable="true" @dragstart="Elmntdragstart(tab,i,elmnt,elmntindex, $event)"></v-list-item-title>									
									
                                                    <v-list-item-icon>									
                                                    <v-icon class="blue--text" v-text="elmnt.Icon"></v-icon>									
                                                    </v-list-item-icon>									
                                                </v-list-item>									
                                    </v-list>									
                                    </v-list>		
                                </v-list>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Documentation Libraries'">
                                 <v-list class="transparent">
                                     <p>Create and maintain a Documentation Library, whereby you can explain services or anythign to your clients and/or users</p>
                                     <!-- uhm little something jsut asking. we don't want any quick config on web forms? -->
                                        <v-menu nudge-right="30" 								
                                            :close-on-content-click="false"                            									
                                            transition="scale-transition"                            									
                                            >									
                                            <template v-slot:activator="{ on }">	
                                            <v-chip 
                                            v-on="on" style="z-index:250;"
                                            icon fab small
                                            >
                                             Add Library
                                            </v-chip>
                                            </template>
                                            <v-card flat width="200">
                                                <v-list style="padding: 0px;" dense class="transparent">
                                                    <v-list-item @click="AddDocumentationLibrary('Public')">
                                                        Public
                                                    </v-list-item>
                                                    <v-list-item @click="AddDocumentationLibrary('Members Only')">
                                                        Members Only
                                                    </v-list-item>
                                                </v-list>
                                            </v-card>
                                        </v-menu>
                                        <v-list-item @click="NavigatetoLibraryEditor(doclib)"
                                        dense v-for="doclib in DocumentationLibraries" :key="doclib.itemObjKey"
                                        :style="'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'"
                                        >
                                        {{doclib.Name}}
                                        </v-list-item>
                                 </v-list>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Add Content'">
                                 <v-row dense>									
                                <v-col cols="6" md="4"									
                                 v-for="block in RenderedContentBlocks" :key="block.itemObjKey">									
                                    <v-card outlined height="100" class="mx-2" width="100%" @dragend="CancelDrag()"									
                                :draggable="true" @dragstart="blockdragstart(block, $event)"> 
                                    <v-list-item two-line>
                                        <v-list-item-content >
                                        <v-avatar tile size="40">
                                            <v-icon size="40">{{block.Icon}}</v-icon>
                                        </v-avatar>

                                        <v-card-subtitle style="text-align:center;line-height:1;padding:0;" class="caption">
                                        {{block.DataViewName? block.DataViewName : block.Name}} 
                                        </v-card-subtitle>
                                </v-list-item-content>
                                    </v-list-item>
                            </v-card>									
                                    </v-col>									
                                </v-row>
                            </v-card-text>
                          
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Site Menu & Pages' && SelectedNavbar || SelectedMain.title === 'Site Menu & Pages' && IsGroupView">
                                
                                <v-overflow-btn style="width:200px;padding-top:5px;"
                                :items="NavbarItems" :placeholder="'Navbar: '+SelectedNavbar.Name" v-model="SelectedNavbar"
                                item-text="Name"
                                    class="elevation-0 noborderoverflow"
                                    dense return-object
                                    ></v-overflow-btn>
                                    <v-list class="transparent">
                                        <v-list-item style="padding-left: 0px;">
                                            <v-chip @click="AddNewPage(SelectedNavbar)" >Add Page <v-icon>mdi-plus</v-icon></v-chip>
                                            <v-chip @click="UpdateMenu()" dark color="success"><v-icon>mdi-content-save</v-icon>Save
                                            </v-chip>
                                        </v-list-item>
                                        <NavMenuPages v-for="(page,pageindex) in ComputedNavbarPages" :key="page.itemObjKey" :SelectedNavbar="SelectedNavbar"
                                        :page="page" :pageindex="pageindex" @OnePropEmit="OnePropEmit" @TwoPropsEmit="TwoPropsEmit" @FourPropsEmit="FourPropsEmit"
                                        />
                                    </v-list>
                            </v-card-text>
                            
                            
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Page Design'">
                                <v-list-item @click="ActivatePageBGDialog()" >
                                <span v-if="EditedPage.PageBGAsset" style="--col: #04AA6D"  class="texbtn btnhover elevation-1">
                            <v-icon style="--col: #04AA6D"  class="btnhover" small>mdi-file</v-icon>Change BG Image
                            </span><span v-if="!EditedPage.PageBGAsset" class="texbtn btnhover elevation-1">
                                <v-icon style="--col: #04AA6D"  class="btnhover" small>mdi-file</v-icon>Select BG Image
                            </span>
                                </v-list-item>
                            <v-select @change="AssignSocialItemInteractMethod('UpdatePageHeadersFont',EditedPage.PageHeadersFont)" v-model="EditedPage.PageHeadersFont" label="Headers Font"                                  
                                :items="FontOptions">
                                <template v-slot:item="{ item }">
                                    <span :style="'font-family:'+item">{{item}}
                                        <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                        </p>
                                        </span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span :style="'font-family:'+item">{{item}}</span>
                                </template>
                                </v-select>
                                <v-select @change="AssignSocialItemInteractMethod('UpdatePageContentFont',EditedPage.PageContentFont)" v-model="EditedPage.PageContentFont" label="Body Font"                                   
                                    :items="FontOptions">
                                <template v-slot:item="{ item }">
                                    <span :style="'font-family:'+item">{{item}}
                                        <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                        </p>
                                        </span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span :style="'font-family:'+item">{{item}}</span>
                                </template>
                                </v-select>	
                                <v-select label="Header size" @change="AssignSocialItemInteractMethod('UpdatePageHeadersFontSize',EditedPage.PageHeadersFontSize)"
                                v-model="EditedPage.PageHeadersFontSize" :items="[24,36,42,50]"									
                                    />	
                            <v-divider vertical></v-divider>
                                    <v-autocomplete @change="AssignSocialItemInteractMethod('UpdatePageBGColor',EditedPage.PageBGColor)"
                                    :items="STDCSSColors" clearable label="Page BG Color" item-text="Name" v-model="EditedPage.PageBGColor">
                                        <template v-slot:item="{ item }">
                                            <span :style="'background-color:'+item.HEX">{{item.Name}}
                                                <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                                </p>
                                                </span>
                                        </template>
                                    </v-autocomplete>
                            <v-spacer></v-spacer>
                                <v-list-item>
                                    <v-text-field label="Page BG Gradient"
                                     @change="AssignSocialItemInteractMethod('UpdatePageBGGradient',EditedPage.PageBGGradient)"
                                     clearable v-model="EditedPage.PageBGGradient"/>
                                </v-list-item>
                                <v-list-item>									
                                    <a href="https://cssgradient.io/" target="_blank">Get Code</a>	
                                </v-list-item>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Media'">
                                <AssetsDirectory :Assets="SystemAssets" :Cols="6" :HoverPreview="true" @ActivateFullGallery="ActivateFullGallery" :ViewFullGalleryBottom="true"
                                :HideSelect="true" :Slice="6"
                                 :ViewFullGalleryText="'See More'"
                                />
                                
                            </v-card-text>
                        </v-card>
                    </v-list>
                </v-navigation-drawer>
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import ContentEditableField from '@/components/Database/ContentEditableField'
import AssetsDirectory from '@/components/WebPages/ConfigComponents/AssetsDirectory';	
import NavMenuPages from '@/components/SuiteBuilder/Navigators/NavMenuPages';	
export default {
    props: ['System','SystemEntities','SitePages','SocialEntities','SystemPhotoLibraries','WebFormEntities','GroupEntities','GraphicalElements','GradientElements','DocumentationLibraries'],
    components: {
        ContentEditableField,
        AssetsDirectory,
        NavMenuPages,
    },
    data() {
        return {
            AppStylingIMGProp: '',
            LibraryColors: [
        'red',
        'white',
        'black',
        'pink',
        'purple',
        'indigo',
        'blue',
        'light-blue',
        'cyan',
        'teal',
        'green',
        'light-green',
        'lime',
        'yellow',
        'amber',
        'orange',
        'deep-orange',
        'brown',
        'blue-grey',
        'grey'
      ],
            Company_Address: {Name: 'Company_Address',FieldBreakdown: [],DisplayName: 'Company Address',CommonFieldType: 'Physical Address',Type: 'Common Field'},
            GalleryLibraries: [],
            FontOptions: ['Architects Daughter','Bahianita','Bangers','Bebas Neue','Berkshire Swash','Caveat','Courgette','Dancing Script','Gudea','Hind','Impact','Indie Flower','Lato','Lobster','Macondo Swash Caps','Maven Pro','Metrophobic','Michroma','Montserrat','Mulish','Mukta Vaani',
                  'News Cycle','Niramit','NTR','Nunito Sans','Oswald','Padauk','Palanquin','Parisienne','Playfair Display','Poiret One','Poppins','Quicksand','Raleway','Redressed','Tangerine','Tulpen One','Verdana','Vibes','Yellowtail'],									
        
            
        SEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        DefaultSEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        SEOBasicsDialog: false,
        PageBasics: [
            {Label: 'Rename', Prop: 'PageName', Icon: 'mdi-pencil', Menu: false},
            {Label: 'Path', Prop: 'PageRoute', Icon: 'mdi-link', Menu: false},
            {Label: 'Rename', Prop: 'PageIcon', Icon: 'mdi-circle', Menu: false}
        ],
        NavItemIndex: -1,
        NavParentIndex: -1,
        SelectedNavbar: {Name: 'Library Navbar',Prop: 'LibraryNavbarItems',PublishType: ''},
        SelectedPage: '',
        SelectedMain: '',
        SelectedMainDialog: false,
        STDCSSColors: [{Name: 'aliceblue', HEX: '#f0f8ff'},{Name: 'antiquewhite', HEX: '#faebd7'},{Name: 'aqua', HEX: '#00ffff'},{Name: 'aquamarine', HEX: '#7fffd4'},{Name: 'azure', HEX: '#f0ffff'},{Name: 'beige', HEX: '#f5f5dc'},{Name: 'bisque', HEX: '#ffe4c4'},{Name: 'black', HEX: '#000000'},{Name: 'blanchedalmond', HEX: '#ffebcd'},{Name: 'blue', HEX: '#0000ff'},{Name: 'blueviolet', HEX: '#8a2be2'},{Name: 'brown', HEX: '#a52a2a'},{Name: 'burlywood', HEX: '#deb887'},{Name: 'cadetblue', HEX: '#5f9ea0'},{Name: 'chartreuse', HEX: '#7fff00'},{Name: 'chocolate', HEX: '#d2691e'},{Name: 'coral', HEX: '#ff7f50'},{Name: 'cornflowerblue', HEX: '#6495ed'},{Name: 'cornsilk', HEX: '#fff8dc'},{Name: 'crimson', HEX: '#dc143c'},{Name: 'cyan', HEX: '#00ffff'},{Name: 'darkblue', HEX: '#00008b'},{Name: 'darkcyan', HEX: '#008b8b'},{Name: 'darkgoldenrod', HEX: '#b8860b'},{Name: 'darkgray', HEX: '#a9a9a9'},{Name: 'darkgreen', HEX: '#006400'},{Name: 'darkgrey', HEX: '#a9a9a9'},{Name: 'darkkhaki', HEX: '#bdb76b'},{Name: 'darkmagenta', HEX: '#8b008b'},{Name: 'darkolivegreen', HEX: '#556b2f'},{Name: 'darkorange', HEX: '#ff8c00'},{Name: 'darkorchid', HEX: '#9932cc'},{Name: 'darkred', HEX: '#8b0000'},{Name: 'darksalmon', HEX: '#e9967a'},{Name: 'darkseagreen', HEX: '#8fbc8f'},{Name: 'darkslateblue', HEX: '#483d8b'},{Name: 'darkslategray', HEX: '#2f4f4f'},{Name: 'darkslategrey', HEX: '#2f4f4f'},{Name: 'darkturquoise', HEX: '#00ced1'},{Name: 'darkviolet', HEX: '#9400d3'},{Name: 'deeppink', HEX: '#ff1493'},{Name: 'deepskyblue', HEX: '#00bfff'},{Name: 'dimgray', HEX: '#696969'},{Name: 'dimgrey', HEX: '#696969'},{Name: 'dodgerblue', HEX: '#1e90ff'},{Name: 'firebrick', HEX: '#b22222'},{Name: 'floralwhite', HEX: '#fffaf0'},{Name: 'forestgreen', HEX: '#228b22'},{Name: 'fuchsia', HEX: '#ff00ff'},{Name: 'gainsboro', HEX: '#dcdcdc'},{Name: 'ghostwhite', HEX: '#f8f8ff'},{Name: 'gold', HEX: '#ffd700'},{Name: 'goldenrod', HEX: '#daa520'},{Name: 'gray', HEX: '#808080'},{Name: 'green', HEX: '#008000'},{Name: 'greenyellow', HEX: '#adff2f'},{Name: 'grey', HEX: '#808080'},{Name: 'honeydew', HEX: '#f0fff0'},{Name: 'hotpink', HEX: '#ff69b4'},{Name: 'indianred', HEX: '#cd5c5c'},{Name: 'indigo', HEX: '#4b0082'},{Name: 'ivory', HEX: '#fffff0'},{Name: 'khaki', HEX: '#f0e68c'},{Name: 'lavender', HEX: '#e6e6fa'},{Name: 'lavenderblush', HEX: '#fff0f5'},{Name: 'lawngreen', HEX: '#7cfc00'},{Name: 'lemonchiffon', HEX: '#fffacd'},{Name: 'lightblue', HEX: '#add8e6'},{Name: 'lightcoral', HEX: '#f08080'},{Name: 'lightcyan', HEX: '#e0ffff'},{Name: 'lightgoldenrodyellow', HEX: '#fafad2'},{Name: 'lightgray', HEX: '#d3d3d3'},{Name: 'lightgreen', HEX: '#90ee90'},{Name: 'lightgrey', HEX: '#d3d3d3'},{Name: 'lightpink', HEX: '#ffb6c1'},{Name: 'lightsalmon', HEX: '#ffa07a'},{Name: 'lightseagreen', HEX: '#20b2aa'},{Name: 'lightskyblue', HEX: '#87cefa'},{Name: 'lightslategray', HEX: '#778899'},{Name: 'lightslategrey', HEX: '#778899'},{Name: 'lightsteelblue', HEX: '#b0c4de'},{Name: 'lightyellow', HEX: '#ffffe0'},{Name: 'lime', HEX: '#00ff00'},{Name: 'limegreen', HEX: '#32cd32'},{Name: 'linen', HEX: '#faf0e6'},{Name: 'magenta', HEX: '#ff00ff'},{Name: 'maroon', HEX: '#800000'},{Name: 'mediumaquamarine', HEX: '#66cdaa'},{Name: 'mediumblue', HEX: '#0000cd'},{Name: 'mediumorchid', HEX: '#ba55d3'},{Name: 'mediumpurple', HEX: '#9370db'},{Name: 'mediumseagreen', HEX: '#3cb371'},{Name: 'mediumslateblue', HEX: '#7b68ee'},{Name: 'mediumspringgreen', HEX: '#00fa9a'},{Name: 'mediumturquoise', HEX: '#48d1cc'},{Name: 'mediumvioletred', HEX: '#c71585'},{Name: 'midnightblue', HEX: '#191970'},{Name: 'mintcream', HEX: '#f5fffa'},{Name: 'mistyrose', HEX: '#ffe4e1'},{Name: 'moccasin', HEX: '#ffe4b5'},{Name: 'navajowhite', HEX: '#ffdead'},{Name: 'navy', HEX: '#000080'},{Name: 'oldlace', HEX: '#fdf5e6'},{Name: 'olive', HEX: '#808000'},{Name: 'olivedrab', HEX: '#6b8e23'},{Name: 'orange', HEX: '#ffa500'},{Name: 'orangered', HEX: '#ff4500'},{Name: 'orchid', HEX: '#da70d6'},{Name: 'palegoldenrod', HEX: '#eee8aa'},{Name: 'palegreen', HEX: '#98fb98'},{Name: 'paleturquoise', HEX: '#afeeee'},{Name: 'palevioletred', HEX: '#db7093'},{Name: 'papayawhip', HEX: '#ffefd5'},{Name: 'peachpuff', HEX: '#ffdab9'},{Name: 'peru', HEX: '#cd853f'},{Name: 'pink', HEX: '#ffc0cb'},{Name: 'plum', HEX: '#dda0dd'},{Name: 'powderblue', HEX: '#b0e0e6'},{Name: 'purple', HEX: '#800080'},{Name: 'red', HEX: '#ff0000'},{Name: 'rosybrown', HEX: '#bc8f8f'},{Name: 'royalblue', HEX: '#4169e1'},{Name: 'saddlebrown', HEX: '#8b4513'},{Name: 'salmon', HEX: '#fa8072'},{Name: 'sandybrown', HEX: '#f4a460'},{Name: 'seagreen', HEX: '#2e8b57'},{Name: 'seashell', HEX: '#fff5ee'},{Name: 'sienna', HEX: '#a0522d'},{Name: 'silver', HEX: '#c0c0c0'},{Name: 'skyblue', HEX: '#87ceeb'},{Name: 'slateblue', HEX: '#6a5acd'},{Name: 'slategray', HEX: '#708090'},{Name: 'slategrey', HEX: '#708090'},{Name: 'snow', HEX: '#fffafa'},{Name: 'springgreen', HEX: '#00ff7f'},{Name: 'steelblue', HEX: '#4682b4'},{Name: 'tan', HEX: '#d2b48c'},{Name: 'teal', HEX: '#008080'},{Name: 'thistle', HEX: '#d8bfd8'},{Name: 'tomato', HEX: '#ff6347'},{Name: 'turquoise', HEX: '#40e0d0'},{Name: 'violet', HEX: '#ee82ee'},{Name: 'wheat', HEX: '#f5deb3'},{Name: 'white', HEX: '#ffffff'},{Name: 'whitesmoke', HEX: '#f5f5f5'},{Name: 'yellow', HEX: '#ffff00'},{Name: 'yellowgreen', HEX: '#9acd32'},
],
        TopItems: [ { title: 'Main', icon: 'mdi-subdirectory-arrow-left',Menu: false,Route: 'SystemConfig/'+process.env.VUE_APP_RA_SYSTEM_ID},],
        sitenavitems: [
        { title: 'Documentation Libraries', icon: 'mdi-book-education' ,Menu: false,},
          { title: 'Site Menu & Pages', icon: 'mdi-home-city',Menu: false},         
        { title: 'Add Content', icon: 'mdi-plus',Menu: false},
          { title: 'Page Design', icon: 'mdi-palette' ,Menu: false},
          { title: 'Page Layout', icon: 'mdi-monitor-dashboard' ,Menu: false},          
          { title: 'Media', icon: 'mdi-folder-image' ,Menu: false},
           { title: 'FAQ', icon: 'mdi-account-question' ,Menu: false, Route: 'FAQAdmin',
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Create and maintain a list of Frequently Asked Questions to add to your Website Pages</p>`
            },
            { title: 'Chatbot', icon: 'mdi-robot',Route: 'ChatbotBuilder' ,
            PreDialog: true,
            IMG: require('@/assets/logo.png'),
            Writeup: `<p>Capitalize on FAQ and configure chatbot for responses. Further expand the chatbot with "virtual assist" responses such as "How many Orders were placed last week".</p>`,},
           
        ],
        
        }
    },
    computed:{
        ActiveDB(){
            //NOTHING FINALIZED HERE. THE MAIN IDEA WAS BUILDING FROM CLIENT SUITE. THE REASON WE DON'T CONTINUE TO PURSUE THIS IS
            //1. WE ARE NOT CALLING GALLERYOBJECTS FOR RA, AND WE SHOULD TRULY NOT
            //2. APPNOTIFICATIONS MAKE STANDARD CLALS WHEN ADDING TO LIBRARIES. we fixed that though
            //mainly then we don't call glalery assets from Ra DB. should we?
            return this.DocumentationLibraryObj && this.DocumentationLibraryObj.Database ? this.DocumentationLibraryObj.Database : db
        },
        DocumentationLibraryObj(){
            let doclibobj = this.DocumentationLibraries.find(obj => obj.id === this.$route.params.id)
            
            if(doclibobj){
                return doclibobj
            }
        },
        ActiveDocumentationLibrary(){
            return this.$store.state.ActiveDocumentationLibrary
        },
        MainDialRight(){
            return this.SelectedMain && this.SelectedMain.title === 'App Styling'
        },
        MainDialStyling(){
            return 'position: fixed;left: 88px;top:190px;z-index:6;height:60%;width:270px;'
        },
        AdvancedComputedLibraryColors(){
      let arr1 = this.LibraryColors
      let arr2 = [
        'primary',
        'accent',
        'secondary',
        'pop',
        'morning',
        'night',
        'fieldcard',
        'links',
        'background',
      ]
      let arr3 = arr1.concat(arr2)
      let arr4 = []
      arr3.map(color => {
        arr4.push(color)
        arr4.push(color+' lighten-1')
        arr4.push(color+' lighten-2')
        arr4.push(color+' lighten-3')
        arr4.push(color+' lighten-4')
        arr4.push(color+' lighten-5')
        arr4.push(color+' darken-1')
        arr4.push(color+' darken-2')
        arr4.push(color+' darken-3')
        arr4.push(color+' darken-4')
        arr4.push(color+' darken-5')
        arr4.push(color+' accent-1')
        arr4.push(color+' accent-2')
        arr4.push(color+' accent-3')
        arr4.push(color+' accent-4')
      })
      return arr4
    },
        ActiveAppStylingNavbar(){
     if(this.$route.name === 'MyAccount'){
       return 'Guest Navbar'
     }
     else if(this.DBBuilderView){
        return 'DB Navbar'
      }
      else if(this.WebsiteBuilderView){
        if(this.$route.meta && this.$route.meta.DataSingleBuilder && this.$route.name !== 'SystemConfig'){
          return 'DB Navbar'
        }
        else{
          return 'Public Navbar'
        }
      }
      else if(this.NetworkBuilderView){
        return 'Social Navbar'
      }
   },
        GroupidRoutes(){
            return this.$store.state.GroupidRoutes
        },
        GroupslugRoutes(){
            return this.$store.state.GroupslugRoutes
        },
        GroupID(){
            if(this.GroupidRoutes.includes(this.$route.name)){
                return this.$route.params.id
            }
            else if(this.$route.query && this.$route.query.GroupID){
                return this.$route.query.GroupID
            }
            else if(this.GroupslugRoutes.includes(this.$route.name)){
                return this.$route.params.slug
            }
        },
        WebForms(){
            if(this.IsGroupView){
                return this.GroupEntities.filter(ent => {
                    return ent.Entity_Type && ent.Entity_Type.Name === 'Web Form' && ent.groupid === this.GroupID
                })
            }
            else{
                return this.WebFormEntities
            }
        },
        IsGroupView(){
        return this.$store.state.IsGroupView
    },
        draggingtab(){
            return this.$store.state.draggingtab
        },
        draggingtabindex(){
            return this.$store.state.draggingtabindex
        },
        draggingelement(){
            return this.$store.state.draggingelement
        },
        draggingelementindex(){
            return this.$store.state.draggingelementindex
        },
        draggingrow(){
            return this.$store.state.draggingrow
        },
        draggingrowindex(){
            return this.$store.state.draggingrowindex
        },
        dragging(){
            return this.$store.state.dragging
        },
        NavbarItems(){
            return [{Name: 'Library Navbar',Prop: 'LibraryNavbarItems',PublishType: ''}]
            // if(this.IsGroupView){
            //     return [{Name: 'Group',Prop: 'GroupNavbarItems',PublishType: ''}]
            // }
            // else{
            //     return [{Name: 'Public',Prop: 'PublicNavbarItems',PublishType: 'Public'},{Name: 'Social',Prop: 'SocialNavbarItems',PublishType: 'Members Only'}]
            // }
        },
        PageTabsPropName(){
            if(this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer){
                return 'SingleBuildTabs'
            }   
            else if(this.$route.meta && this.$route.meta.ClassifiedListingBuilder){
                return 'ClassifiedTabs'
            }
            else if(this.$route.meta && this.$route.meta.WikiListingBuilder){
                return 'WikiTabs'
            }
            else{
                return 'PageTabs'
            }
        //return this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer? 'SingleBuildTabs' : 'PageTabs'
    },		
        PageTabs(){
            console.log('EditedPage',this.EditedPage)
            return this.EditedPage ? this.EditedPage[this.PageTabsPropName] : []
        },
        EditedPage(){
            return this.$store.state.EditedPage
        },
        RenderedContentBlocks(){
            return this.$store.state.RenderedContentBlocks
        },
        BuilderView(){
        return this.$store.state.BuilderView
        },
        WebsiteBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Website Builder'
        },
        DBBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Database Builder'
        },
        NetworkBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Social Network Builder'
        },
        CanEditDocLib(){
            return this.ActiveDocumentationLibrary && !this.DocLibisRADB && this.userIsAdmin
            || this.ActiveDocumentationLibrary && this.DocLibisRADB && this.RAAdmin
        },
        RAAdmin(){
            return this.RAUserObj && this.RAUserObj.rolesarrayDBRules && this.RAUserObj.rolesarrayDBRules.SystemAdmin
        },
        RAUserObj(){
            return this.$store.state.RAUserObj
        },
        RADB(){
            return this.$store.state.RADB
        },
        DocLibisRADB(){
            return this.ActiveDocumentationLibrary && this.ActiveDocumentationLibrary.Database && this.ActiveDocumentationLibrary.Database === this.RADB
        },
        SystemAssets(){
            return this.DocLibisRADB ? this.$store.state.RASystemAssets : this.$store.state.SystemAssets
        },
        MiniView(){
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        SiteDialog(){
            return this.$store.state.SiteDialog
        },
        SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },
      FilteredTopItems(){
            return this.TopItems.filter(item => {
                if(!this.IsGroupView || this.IsGroupView && this.$route.name === 'GroupEdit'){
                    return item.title !== 'Main'
                }
                else{
                    return item
                }
            }).map(item => {
                if(this.IsGroupView && item.title === 'Main'){
                   item.Route = 'Group/Edit/'+this.GroupID  
                }
                return item
            })
      },
        Computedsitenavitems(){
            return this.sitenavitems.filter(item => {
                if(this.$route.meta.DataSingleBuilder && this.$route.name !== 'SystemConfig'){
                    return item.title === 'Add Content' || item.title === 'Page Layout'
                }
                else if(this.$route.name === 'SystemConfig'){
                    return item.title === 'Site Menu & Pages' || item.title === 'Media'
                }
                else if(this.$route.name === 'newlandingpage'){
                    
                    return item.title !== 'Site Menu & Pages'
                }
                else if(this.IsGroupView && this.$route.name !== 'GroupPageEditor'){                    
                    return item.title !== 'Add Content' && item.title !== 'Chatbot'
                    && item.title !== 'FAQ' && item.title !== 'Page Design' && item.title !== 'Page Layout'
                    //later we will add FAQ back in to groups for sure
                }
                else if(this.IsGroupView){                    
                    return item.title !== 'Chatbot'
                    && item.title !== 'FAQ'
                    //later we will add FAQ back in to groups for sure
                }
                else{
                    return item
                }
            })
        },
        ComputedNavbarPages(){
            return this.NavbarPages.map(page => {
                //console.log('ComputedNavbarPages',page)
                page.OnMenu = false
                let oncheck = this.ComputedNavList.find(obj => obj.id === page.id)
                if(oncheck){
                    page.MenuIndex = oncheck.MenuIndex
                    page.OnMenu = true
                    if(oncheck.Children){
                        page.Children = oncheck.Children.map(child => {
                            let childpageobj = Object.assign({},this.NavbarPages.find(obj => obj.id === child.id))
                            childpageobj.MenuIndex = child.MenuIndex
                            //console.log(child,childpageobj)
                            return childpageobj
                        })
                    }
                }
                // else if(page.SubPage){
                //     page.OnMenu = true
                // }
                else{
                    page.OnMenu = false
                    page.MenuIndex = 100000
                }
                return page
            })
            .filter(page => {
                return !page.SubPage
            })
            .map(page => {
                if(page.OnMenu){
                    page.RenderStyling = 'links--text'
                }
                else{
                    page.RenderStyling = 'grey--text'
                }
                return page
            })
            .sort((a, b) => {
                var key1 = a.MenuIndex;
                var key2 = b.MenuIndex;

                if (key1 < key2) {
                    return -1;
                } else if (key1 == key2) {
                    return 0;
                } else {
                    return 1;
                }
        })
        },
        
        ActiveGroup(){
            return this.$store.state.ActiveGroup
        },
        ComputedSitePages(){
            //console.log('this.ActiveDocumentationLibrary',this.ActiveDocumentationLibrary)
            if(this.IsGroupView){
                //console.log(this.ActiveGroup)
                return this.ActiveGroup && this.ActiveGroup.Pages ? this.ActiveGroup.Pages : []
            }
            else{
                return this.ActiveDocumentationLibrary.Pages
            }
        },
        NavListArray(){
            return this[this.NavlistHolder] && this.SelectedNavbar && this[this.NavlistHolder][this.SelectedNavbar.Prop] ? this[this.NavlistHolder][this.SelectedNavbar.Prop]
            : []
        },
        NavlistRef(){
            return this.NavlistHolder === 'ActiveGroup' && this.ActiveGroup ? this.ActiveDB.collection('groups').doc(this.ActiveGroup.id) : 
            this.ActiveDB.collection('SystemConfig').doc(this.DocumentationLibraryObj.SystemID).collection('DocumentationLibraries').doc(this.$route.params.id)
        },
        NavlistHolder(){
            if(this.IsGroupView){
                return 'ActiveDocumentationLibrary'
            }
            else{
                return 'ActiveDocumentationLibrary'
            }
        },
        ComputedNavList(){
            let arr = this.NavListArray
            //console.log(arr)
            return arr.map((item,arrindex) => {
                item.MenuIndex = arrindex
                return item
            })
        },
        NavbarPages(){
           return this.ComputedSitePages        
        },
        DefaultPath(){
            //UpdateSEOBasics
            if(this.$route.name === 'PageEditor'){
                return this.System.ClientAppURL+'/'
            }
            else if(this.IsGroupView){
                return this.System.ClientAppURL+'/Group-Page/'+this.GroupID+'/'
            }
        },
        userLoggedIn () {
        return this.$store.getters.user
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
        SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },
    },
    watch: {
        EditedPage : {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue && !oldvalue){
                    this.SelectedNavbar.PublishType = this.EditedPage.PublishType
                    //this.PrepNavbar(newvalue)
                    
                }
            },deep: true
        },
        SelectedMain (value){
            if(value){
                this.SelectedMainDialog = true
            }
            else{
                this.SelectedMainDialog = false
            }
        },
        SocialItemInteractMethod(v){   
        let acceptedmethods = ['PushtoPreviousNavItem']   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){
        //console.log(this.$route.name,this.IsGroupView)
    },
    methods:{
        OnePropEmit(Method,Prop){
            this[Method](Prop)
            //console.log(Method,Prop)
        },
        FourPropsEmit(Method,Prop,SecondProp,ThirdProp,FourthProp){
            this[Method](Prop,SecondProp,ThirdProp,FourthProp)
            //console.log(Method,Prop,SecondProp,ThirdProp,FourthProp)
        },
        TwoPropsEmit(Method,Prop,SecondProp){
            this[Method](Prop,SecondProp)
            //console.log(Method,Prop,SecondProp)
        },
        PageItemStyle(page,parentpage){
            let style = ''
            if(!page.SubPage){
                if(this.SelectedPage.Name === page.Name){
                    style = 'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }
                else{
                    style = 'border: 1px solid #eee !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }
            }
            else{
                // padding-left: 30px !important;
                if(this.SelectedPage.Name === page.Name){
                    style = 'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }
                else{
                    style = 'border: 1px solid #eee !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }  
            }
            //console.log(style)
            return style
            
        },
        NavigatetoLibraryEditor(doclib){
            let path = '/DocumentationLibraryEditor/'+doclib.id+'/'+doclib.FirstPageName.split(' ').join('-')
            if(this.$route.path !== path){
                this.$router.push(path)
            }
        },
        AddDocumentationLibrary(PublishType){
             this.AssignSocialItemInteractMethod('ToggleNewDocLibDialog',PublishType)
        },
        PrepareActivateFullGallery(prop){
            this.$store.commit('setIMGProp','AppStylingIMG')
            this.AppStylingIMGProp = prop
            this.ActivateFullGallery()
        },
        AssignImageandCloseTab(){
            console.log('AssignImageandCloseTab')
            if(this.IsGroupView){
                this.ActiveGroup[this.AppStylingIMGProp] = this.SelectedImage
            }
            else{
                this.System[this.AppStylingIMGProp] = this.SelectedImage
            }
        },
        UpdateGroupStyling(){
      if(this.ActiveGroup.NavBar_IMG){
         db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavBar_IMG: this.ActiveGroup.NavBar_IMG
        })
      }     
      if(this.ActiveGroup.NavbarTextColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavbarTextColor: this.ActiveGroup.NavbarTextColor
        })
      }
      if(this.ActiveGroup.NavbarBGColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavbarBGColor: this.ActiveGroup.NavbarBGColor
        })
      }
      if(this.ActiveGroup.NavItemsBGColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavItemsBGColor: this.ActiveGroup.NavItemsBGColor
        })
      }
      if(this.ActiveGroup.NavItemsTextColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavItemsTextColor: this.ActiveGroup.NavItemsTextColor
        })
      }
      
    },
        SetColorstoSystemColors(System){
            this.$emit('SetColorstoSystemColors',System)
        },
        PrepareAddressField(fieldname,obj){
        let field = this[fieldname]
        
        field.FieldBreakdown = []
        let StreetNumber = {Name: field.Name+'_Street_Number',DisplayName: 'Street Number', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: '', SampleText: '1'}
        let StreetName = {Name: field.Name+'_Street_Name',DisplayName: 'Street Name', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: '', SampleText: 'Long Street'}
        let Suburb = {Name: field.Name+'_Suburb',DisplayName: 'Suburb', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'SmallVille'}
        let City = {Name: field.Name+'_City',DisplayName: 'City', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'Big Town'}
        let PostalCode = {Name: field.Name+'_Postal_Code',DisplayName: 'Postal Code', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, SampleText: '1777'}
        let StateProvince = {Name: field.Name+'_State_Province',DisplayName: 'State Province', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'FarmState'}
        let CountryRegion = {Name: field.Name+'_Country_Region',DisplayName: 'Country Region', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'DisneyLand'}
        field.FieldBreakdown = []
        field.FieldBreakdown.push(StreetNumber)
        field.FieldBreakdown.push(StreetName)
        field.FieldBreakdown.push(Suburb)
        field.FieldBreakdown.push(City)
        field.FieldBreakdown.push(PostalCode)
        field.FieldBreakdown.push(StateProvince)
        field.FieldBreakdown.push(CountryRegion)
        field.Response = {
            [field.Name+'_Street_Number'] : obj[field.Name+'_Street_Number'],
            [field.Name+'_Street_Name'] : obj[field.Name+'_Street_Name'],
            [field.Name+'_Suburb'] : obj[field.Name+'_Suburb'],
            [field.Name+'_City'] : obj[field.Name+'_City'],
            [field.Name+'_Postal_Code'] : obj[field.Name+'_Postal_Code'],
            [field.Name+'_State_Province'] : obj[field.Name+'_State_Province'],
            [field.Name+'_Country_Region'] : obj[field.Name+'_Country_Region']
        }
        //console.log(obj,obj[field.Name+'_Street_Number'],field.Name+'_Street_Number',StreetNumber,field.Response)
      },
        
        CancelDrag(){
            this.$store.commit('setdragging','') 
        },
        blockdragstart(block) {									
        //console.log(block)	
        this.$store.commit('setdragging',block) 								
        },
        HideTabElements(i){
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','HideTabElements')
        },
        ShowTabElements(i){
            //console.log(i)
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','ShowTabElements')
        },
        Elmntdragstart(tab,tabindex,elmnt,elmntindex){		
            //console.log(tab,tabindex,elmnt,elmntindex)	
            this.$store.commit('setdraggingtab',tab) 
            this.$store.commit('setdraggingtabindex',tabindex)
            this.$store.commit('setdraggingelement',elmnt)
            this.$store.commit('setdraggingelementindex',elmntindex)								
        },									
        Elmntdragfinish(to,ev){							
            //console.log(this.draggingrow)							
            this.PageTabs[this.draggingtabindex].Elements.splice(to, 0, this.PageTabs[this.draggingtabindex].Elements.splice(this.draggingelementindex, 1)[0]);	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Elmntdragfinish')
        },
        Tabdragstart(row,rowindex){									
            this.$store.commit('setdraggingrow',row) 
            this.$store.commit('setdraggingrowindex',rowindex)				
        },									
        Tabdragfinish(to,ev){	
            this.$store.commit('SetSocialItemInteractMethodProp',to) 
            this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')								
            this.PageTabs.splice(to, 0, this.PageTabs.splice(this.draggingrowindex, 1)[0]);	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')						
        },	
        GetGalleryObjects(){									
            let routes = this.$router.getRoutes()									
            let GalleryPaths = routes.filter(option => {return option.meta && option.meta.photolibrary})									
            console.log('GalleryPaths',GalleryPaths)									
            GalleryPaths.map(path => {	
                let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                if(!check){		
                    let libraryobj = {									
                        name: path.meta.subcat,									
                        compname: path.meta.subcat.split(' ').join(''),									
                        Assets: [],								
                    }	
                    let libentity = this.SystemPhotoLibraries.find(obj => obj.id === path.meta.EntityID)	
                    if(libentity){
                        if(libentity.CustomTags){
                            libraryobj.CustomTags = libentity.CustomTags  
                            libraryobj.EntityCollectionRef = db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('PhotoLibraries').doc(libentity.id)	
                        }
                        libraryobj.TableCollectionRef = db.collection(libentity.id.split('_').join('').toLowerCase())
                        this.GalleryLibraries.push(libraryobj)	
                        this.GetGalleryItems(path)                                    
                    }
                }
                else{
                    this.GetGalleryItems(path) 
                }						
            })									
        },									
        GetGalleryItems(path){									
            db.collection(path.name).onSnapshot(res => {									
                        const changes = res.docChanges();									
                        changes.forEach(change => {									
                          if (change.type === 'added') {									
                              let returnobj = {									
                              ...change.doc.data(),									
                              id: change.doc.id									
                            }									
                            //console.log(typeof this.SystemAssets)									
                            // returnobj.Library = path.meta.subcat									
                            let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                            check.Assets.push(returnobj)									
                            //console.log(this.GalleryLibraries)									
                            									
                          }									
                        })									
                      })									
        },	
        
        //['ShowTabElements','HideTabElements','OpenDialog','AdjustRowAmount','Elmntdragstart','Elmntdragfinish','NoPropsemit','blockdragstart']
        // /AssignSocialItemInteractMethod(item,SecondProp)

        CancelNavItemDrag(){
            this.NavItemIndex = -1
            this.NavParentIndex = -1
        },
        NavItemDragStart(index,parentindex){
            //console.log(index)
            this.NavItemIndex = index
            if(parentindex){
                this.NavParentIndex = parentindex
            }
        },		
        NavItemDragFinish(index){
            console.log(index)
            if(this.NavParentIndex === -1){
             this.NavListArray.splice(index,0, this.NavListArray.splice(this.NavItemIndex, 1)[0])   
            }
            else{
                //actualy have to check if parent is...uhm...parent?
                let parentpage = this.NavListArray[this.NavParentIndex]               
                let fromistring = this.NavItemIndex
                let fromindex = fromistring.split('.')[1]                
                let from = Number(fromindex)-1
                let toistring = index
                let toindex = toistring.split('.')[1]
                let parentindex = toistring.split('.')[0]
                if(this.NavParentIndex === Number(parentindex)){
                let to = Number(toindex)-1
                console.log(from,to)
                parentpage.Children.splice(to,0, parentpage.Children.splice(from, 1)[0]) 
                parentpage.Children.map((child,childindex) => {
                    let parentnext = childindex-1+2
                    let newindex = this.NavParentIndex+'.'+parentnext
                    child.MenuIndex = newindex
                })               
                this.RefreshTitleDialog()
                }
                else{
                    alert('Cannot move between parents')
                }
                
            }
            console.log(this.NavListArray)
        },
        UpdateContentEditableField(prop,value,AdditionalSaveMethod,FieldObject){
            FieldObject[prop] = value
            console.log(AdditionalSaveMethod)
            if(AdditionalSaveMethod){
                this[AdditionalSaveMethod]()
            }
        },
        DeactivateSEODialog(){
            this.SEOBasicsDialog = false
            this.SEOPage = Object.assign({},this.DefaultSEOPage)
        },
        UpdateSEOBasics(){
            let updatepath = ''
            if(this.$route.name === 'PageEditor'){
                updatepath = db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('Pages').doc(this.SEOPage.id)
            }
            else if(this.IsGroupView){
                updatepath = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).collection('pages').doc(this.SEOPage.id)
            }
            updatepath.update({
                Overview: this.SEOPage.Overview,
                KeyWords: this.SEOPage.KeyWords,
                SEO: this.SEOPage.SEO
            }).then(updatedpage => {
                this.DeactivateSEODialog()
            })
        },
        ActivateSEOBasicsDialog(page){
            this.SEOPage = {
                Overview: page.Overview,
                KeyWords: [],
                PageRoute: page.PageRoute,
                Name: page.Name,
                Icon: page.PageIcon,
                id: page.id,
                SEO: false,
            }
            if(page.KeyWords){
                this.SEOPage.KeyWords = page.KeyWords
            }
            if(page.SEO){
                this.SEOPage.SEO = page.SEO
            }
            this.SEOBasicsDialog = true
        },
        ChangePageProp(page,Prop){
        },
        UpdatePageProp(page,Prop){
            let updatepath = this.ActiveDB.collection('SystemConfig').doc(this.DocumentationLibraryObj.SystemID)
            .collection('DocumentationLibraries').doc(this.$route.params.id)
            .collection('Pages').doc(page.id)
            updatepath.update({
                [Prop]: page[Prop]
            })
        },
        ActivatePageBGDialog(){
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.SystemAssets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('setIMGProp','PageBGAsset')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        ActivateFullGallery(){
            console.log('ActivateFullGallery')
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.SystemAssets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        RemovePagefromNavlistArray(page){
            let item = this[this.NavlistHolder][this.SelectedNavbar.Prop].find(obj => obj.title === page.Name)
            if(item){
                item.OnMenu = false
                item.MenuIndex = 100000
                let index = this[this.NavlistHolder][this.SelectedNavbar.Prop].indexOf(item)
                this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(index,1)
            }
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
        },
        PushPageUpwards(page){
            //console.log(page)
            let parentindex = page.MenuIndex.split('.')[0]
            parentindex = Number(parentindex)
            console.log(page.MenuIndex,parentindex)
            //MOYO IMPORTANTE!!!! WHEN MANIPULATING WE SHOULD INF ACT MANIPULATE COMPUTEDNAVLIST, BECAUSE COMPUTEDNAVBARPAGES REFER TO IT
            //Here by example, we first used Navbarpages to obtain parent page. when you splice the children array it removes but immediatley pushes back in due to computednavlist obj still having it as a child
            let parentpage = this.ComputedNavList.find(obj => obj.id === page.Parentid)            
            let childindex = page.MenuIndex.split('.')[1]
            childindex = Number(childindex)-1
            //console.log(parentpage.Children.length)
            parentpage.Children.splice(childindex,1)
            // console.log(parentpage.Children.length)
            // console.log(parentpage,childindex)
            let pageobj = this.NavbarPages.find(obj => obj.id === page.id)
            pageobj.SubPage = false
            page.SubPage = false
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: parentindex-1+2,
            }   
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            if(parentpage.OnMenu){
                navpage.OnMenu = parentpage.OnMenu
            }
            this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(parentindex-1+2,0,navpage)
            
            this[this.NavlistHolder][this.SelectedNavbar.Prop].map((item,itemindex) => {
                item.MenuIndex = itemindex
                if(item.Children){
                    item.Children.map((child,childindex) => {
                    let parentnext = childindex-1+2
                    let newindex = item.MenuIndex+'.'+parentnext
                    child.MenuIndex = newindex
                })
                }
                
            })
            this.RefreshTitleDialog()
        },
        SortChildrenAlphabetically(page){
            let parentpage = this.NavListArray[page.MenuIndex]
            console.log(parentpage)
            parentpage.Children.sort((a, b) => {
                var key1 = a.title;
                var key2 = b.title;
                if (key1 < key2) {
                    return -1;
                } else if (key1 == key2) {
                    return 0;
                } else {
                    return 1;
                }
             }).map((child,childindex) => {
                    let parentnext = childindex-1+2
                    let newindex = parentpage.MenuIndex+'.'+parentnext
                    //console.log(newindex,typeof newindex,Number(newindex).toFixed(3))
                    child.MenuIndex = newindex
                })
                this.RefreshTitleDialog()
                //console.log(page)
        },
        PushtoPreviousNavItem(page){
            let fromaddpage = false
            let parentindex = 0
            if(this.NavParentIndex !== -1){
                fromaddpage = true
                parentindex = this.NavParentIndex
                this.NavParentIndex = -1
            }
            else{
                parentindex = page.MenuIndex-1
            }
            console.log(fromaddpage,parentindex)
            let parentpage = this[this.NavlistHolder][this.SelectedNavbar.Prop][parentindex]
            if(!parentpage.Children){
                parentpage.Children = []
            }
            let parentnext = parentpage.Children.length-1+2
            let newindex = parentindex+'.'+parentnext
           //console.log(newindex,typeof newindex,parentpage)
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: newindex,
                ParentIndex: parentindex,
                Parentid: parentpage.id
            }   
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            console.log(page,parentpage,navpage,newindex)     
            if(!fromaddpage){
              this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(page.MenuIndex,1)  
            }            
            parentpage.Children.push(navpage)
            page.SubPage = true
           this.RefreshTitleDialog()
        },
        RefreshTitleDialog(){
            let title =this.SelectedMain.title
                this.SelectedMain.title = ''
                setTimeout(() => {
                    this.SelectedMain.title = title
                    console.log(this[this.NavlistHolder][this.SelectedNavbar.Prop])
                }, 10); 
        },
        PushPagetoNavlistArray(page){
            page.SubPage = false
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: this[this.NavlistHolder][this.SelectedNavbar.Prop].length
            }
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            this[this.NavlistHolder][this.SelectedNavbar.Prop].push(navpage)
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
        },
        UpdateMenu(){
            if(this.NavListArray){
             this.NavlistRef.update({
                [this.SelectedNavbar.Prop]: this.NavListArray
            })
            let flatnavlist = this.NavListArray.map(item => {
                let arr = []
                if(item.Children){
                    arr = [item].concat(item.Children)
                }
                else{
                    arr = [item]
                }
                return arr
            }).flat()
            //console.log(flatnavlist)
            this.NavbarPages.map(page => {
                let item = flatnavlist.find(obj => obj.id === page.id)
                //console.log(page.id,item)
                if(!item){
                    page.SubPage = false
                    page.MenuIndex = ''
                    if(page.ParentIndex !== ''){
                        page.ParentIndex = ''
                        page.Parentid = ''
                    }
                }
                else{
                    page.MenuIndex = item.MenuIndex
                    this.UpdatePageProp(page,'MenuIndex')
                    if(typeof page.SubPage !== 'undefined'){
                    this.UpdatePageProp(page,'SubPage')  
                    }       
                    if(typeof item.ParentIndex !== 'undefined'){
                        page.ParentIndex = item.ParentIndex
                        this.UpdatePageProp(page,'ParentIndex')
                        page.Parentid = item.Parentid
                        this.UpdatePageProp(page,'Parentid')
                    }

                }
                
            }) 
            // this.NavListArray.map(item => {   
            //     let page =this.NavbarPages.find(obj => obj.id === item.id)
            //     if(typeof page.SubPage !== 'undefined'){                    
            //         this.UpdatePageProp(page,'SubPage')                       
            //     }  
            //     this.UpdatePageProp(page,'MenuIndex')
            //     // if(item.Children){
            //     //     //console.log(page)
            //     //         item.Children.map(child => {
            //     //             let childpage =this.NavbarPages.find(obj => obj.id === child.id)
            //     //             //console.log(childpage)
            //     //             childpage.SubPage = true
            //     //             childpage.MenuIndex = child.MenuIndex
            //     //             this.UpdatePageProp(childpage,'SubPage') 
            //     //             this.UpdatePageProp(childpage,'MenuIndex') 
            //     //         })
            //     //     }              
            // })
            }
            
        },
        PageClass(page){
            if(this.SelectedPage.Name === page.Name){
                if(this.$vuetify.theme.dark){
                   return 'background lighten-2 sitenavitem' 
                }                
            }
            else{
                if(this.$vuetify.theme.dark){
                return 'background sitenavitem'
                }
                else{
                 return 'sitenavitem'   
                }
            }
        },
        
        AddNewPage(navbar,SubPage,parentindex){
            //console.log(navbar,SubPage,parentindex)
          if(typeof parentindex !== 'undefined'){
              this.NavParentIndex = parentindex
              this.$store.commit('SetRandomInteractProp','New Page as SubPage')
              console.log(this.NavParentIndex)
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog',this.ActiveDocumentationLibrary.PublishType)
          }
          else{
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog',this.ActiveDocumentationLibrary.PublishType)
          }
        },
        AssignSocialItemInteractMethod(item,SecondProp){
        console.log('AssignSocialItemInteractMethod',item,SecondProp)
        this.$store.commit('SetSocialItemInteractMethodProp','') 
        this.$store.commit('SetSocialItemInteractMethod','')
        if(SecondProp){
            this.$store.commit('SetSocialItemInteractMethodProp',SecondProp) 
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        else if(item){
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        },
        AssignRenderedContentBlocks(blocks){
            //console.log('sure we assign blocks',blocks)
            //THIS BECOMES STORE COMMIT
            this.RenderedContentBlocks = blocks
        },
        ActivateSelectedMain(main,frompredial){
            //console.log(main)
            if(main.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.SecondProp && main.SecondProp.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.Method){
                this.SelectedMainDialog = false
                this.SelectedMain = ''
             this.AssignSocialItemInteractMethod(main.Prop,main.SecondProp)   
            }
            else if(main.Route){
                this.$router.push('/'+main.Route)
            }
            else{
                this.SelectedMain = main
            }
        },
        NavigatetoWebFormEditor(entityid){
             if(entityid !== this.$route.params.id){
                if(this.IsGroupView){
                    this.$router.replace({name: 'GroupWebFormEditor', query: {GroupID: this.GroupID},params: {id: entityid}})  
                }
                else{
                    this.$router.push('/WebFormEditor/'+entityid)
                }
             }        
        },
        NavigatetoWebFormBuilder(){
            if(this.IsGroupView){
             this.$router.replace({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}})   
            }
            else{
                this.$router.push('/WebFormBuilder-New')
            }
            
            // let routeData = this.$router.resolve({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}});
            // window.open(routeData.href, '_blank');
        },
        SelectOtherPage(page){
            this.EditOtherPage(page)
        },
        EditOtherPage(SelectedPage){
            let newpath = '/DocumentationLibraryEditor/'+this.$route.params.id+'/'+SelectedPage.id
            if(this.IsGroupView){
                this.$router.push(newpath)
            }
            else{
                this.$router.push(newpath)
            }
        },
        
        AddContentDialog(EditedTab){
            if(EditedTab.ContentDialogType){
                let contentbox = this.ContentBlocks.find(obj => obj.Name === EditedTab.ContentDialogType.Name)
                EditedTab.ContentDialogBox = Object.assign({},contentbox)
                EditedTab.ContentDialogBox.Elevation = 0
                EditedTab.ContentDialogBox.Tile = true
                EditedTab.ContentDialogBox.Flat = true
                EditedTab.ContentDialogBox.IsContentDialog = true
            }
        },
    }
}
</script>

<style>

</style>



